import { AlertTriangle } from "lucide-react";

/**
 * BM-H285. Shown in place of a matter picker dropdown when the matter list
 * could not be read.
 *
 * The point of this component is that an empty dropdown is not allowed to be
 * the only signal a fee earner gets when the read failed. An empty dropdown
 * means "the list was read and nothing matched". This banner means "the list
 * was not read, so draw no conclusion". A toast is not enough on its own,
 * because it disappears and the empty dropdown stays.
 *
 * Renders nothing when there is no message, so it can sit unconditionally
 * beside every picker.
 */
export default function MatterSearchUnavailableNotice({ message }) {
  if (!message) return null;
  return (
    <div
      role="alert"
      data-testid="matter-search-unavailable"
      className="mt-1 flex items-start gap-2 rounded-md border border-status-red bg-status-red-dim px-3 py-2 text-xs text-status-red"
    >
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
